import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-grid',
	templateUrl:'./WaGridPage.html',
	styles: [],
	styleUrls:['./WaGridPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaGridPage
{
	mdContent_349 = `\`\`\`java
import com.jwebmp.webawesome.components.WaGrid;
\`\`\``;
	mdContent_350 = `\`\`\`java
var grid = new WaGrid<>();
grid.setMinColumnSize("18rem");
grid.setGap(PageSize.Small);
grid.add(card1);
grid.add(card2);
\`\`\``;
}
